import { Entity } from '../reactives/Entity.js';
function existsFilter(x) {
    return x !== null;
}
export function filterResultSet(results) {
    if (Array.isArray(results)) {
        return results.map(filterResultSet).filter(existsFilter);
    }
    else if (results instanceof Entity) {
        return results.deleted ? null : results;
    }
    else {
        return results;
    }
}
//# sourceMappingURL=utils.js.map